module.exports = __webpack_public_path__ + "static/wlm-lazy-peon-meets-legendary-abac66d288e99005d293f8081c3ccf28.jpg";